// extracted by mini-css-extract-plugin
export default {"madeWithLove":"made-with-love-module--made-with-love--OHBvc","pulse":"made-with-love-module--pulse--9R42Q"};